import styled from 'styled-components';
import { SIZES } from 'common/constants/sizes';
import { cssWhiteSection } from 'components/base/common-styles';

export const StyledChartRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  height: 40rem;
  overflow: hidden;
`;

export const StyledRowHeader = styled.header`
  display: flex;
  align-items: flex-start;
  height: 10%;

  font-size: 1.5rem;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.3px;
  text-transform: uppercase;
`;

export const StyledRowContent = styled.main`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 90%;
`;

export const StyledProgressionOverTimeWrapper = styled.div`
  ${cssWhiteSection};
  width: 70%;
`;
export const StyledInsightsWrapper = styled.div`
  ${cssWhiteSection};
  width: 29%;
`;
export const StyledProgressionTableWrapper = styled.div`
  ${cssWhiteSection};
  min-height: 30rem;
`;

export const StyledProjectProgression = styled.div`
  font-size: ${SIZES.medium};
  height: 100%;
`;
